/* import components */
import Menu from "../components/Menu";
import Container from "react-bootstrap/Container";

const Error = () => {

  return (
    <>  
      <Menu title="RydeHELP" />
      <Container style={{ paddingTop: "20px", textAlign: "center"}}>
          <h1>404</h1>
          <p style={{ fontSize: "16px", textAlign: "center"}}>Error! The requested path could not be found.</p>
      </Container>
    </>
    );
}

export default Error;